import React, { useState, useMemo } from "react";
import AddNewSvg from "../../../PatientDashboardIcons/addNew.svg";
import useTitanApp from "../../../../../hooks/useTitanApp";
import { Dropdown } from "primereact/dropdown";
import dayjs from "dayjs";
import {
  setCurrentPatientPrescription,
  setCurrentShowPatientPrescriptionModal,
} from "../../../../../dispatchers/patientDispatchers";
import Skeleton from "@mui/material/Skeleton";

function DashboardPrescriptions() {
  const { patientState, appState } = useTitanApp();
  const { showPatientConsultationsLoader, patientConsultations } = patientState;
  const [selectedRange, setSelectedRange] = useState(null);
  const { darkMode } = appState || {};

  const dateRanges = [
    { label: "All", value: "all" },
    { label: "Last 30 days", value: 30 },
    { label: "Last 20 days", value: 20 },
    { label: "Last 10 days", value: 10 },
  ];

  const previousPrescriptions = useMemo(() => {
    return (
      patientConsultations?.flatMap((consultation) =>
        (consultation?.actions || [])
          ?.filter((action) => action?.actionNumber === "1")
          ?.map((action) => ({
            action,
            createdOn: consultation.createdOn,
            consultationId: consultation.consultationId,
          }))
      ) || []
    );
  }, [patientConsultations]);

  const filteredPrescriptions = useMemo(() => {
    if (!previousPrescriptions) return [];
    if (!selectedRange || selectedRange === "all") return previousPrescriptions;

    return previousPrescriptions.filter((item) => {
      const daysAgo = dayjs().subtract(selectedRange, "day");
      return dayjs(item.createdOn).isAfter(daysAgo);
    });
  }, [previousPrescriptions, selectedRange]);

  const handleViewPrescription = async (prescription) => {
    setCurrentPatientPrescription(prescription);
    setCurrentShowPatientPrescriptionModal(true);
  };

  return previousPrescriptions?.length === 0 &&
    !showPatientConsultationsLoader ? null : (
    <div
      className="db-prescriptions-container"
      id="prescription-history-wrapper-id"
    >
      {showPatientConsultationsLoader ? (
        <div className="appointment-skeleton-wrapper">
          {[...Array(3)].map((_, i) => (
            <Skeleton
              key={i}
              sx={{
                bgcolor: darkMode ? "grey.800" : "",
                width: "100%",
                height: "70px",
                borderRadius: "16px",
                marginBottom: "10px",
              }}
              variant="rounded"
            />
          ))}
        </div>
      ) : (
        <>
          {previousPrescriptions.length > 0 && (
            <div className="prescription-history-wrapper">
              <div className="tasks_header header_appointment">
                <div>
                  <h3 className="pharmacy_header_name">
                    Prescriptions ({previousPrescriptions.length})
                  </h3>
                  <p className="mt-1">
                    {selectedRange && selectedRange !== "all"
                      ? `Showing prescriptions from the last ${selectedRange} days`
                      : "Showing all prescriptions."}
                  </p>
                </div>
                <Dropdown
                  value={selectedRange}
                  onChange={(e) => {
                    setSelectedRange(e.value);
                  }}
                  options={dateRanges}
                  placeholder="Select Range"
                  className="dropdown"
                  panelClassName="bucket-dropdown-panel"
                />
              </div>

              {filteredPrescriptions.length > 0 && (
                <div className="prescriptions-slide">
                  {filteredPrescriptions.map((item, idx) => {
                    let prescriptionsDetails = [];
                    try {
                      const payload = JSON.parse(item.action.payload);
                      prescriptionsDetails = payload.prescriptionsDetails || [];
                    } catch (error) {
                      console.error("Error parsing payload:", error);
                    }

                    const formattedDate = dayjs(item.createdOn).format(
                      "DD/MM/YY"
                    );

                    return prescriptionsDetails.map((detail, detailIdx) => (
                      <div
                        className="prescription-container"
                        key={`${idx}-${detailIdx}`}
                        // onClick={() => handleViewPrescription(detail)} disabled temporarily
                      >
                        <div className="prescription-image"></div>
                        <div className="prescription-heading-date">
                          <p>RX #{detail.value || "Unnamed"}</p>
                          <p>{formattedDate}</p>
                        </div>
                      </div>
                    ));
                  })}
                </div>
              )}
              {filteredPrescriptions.length > 0 && (
                <div className="dispensed-medications-wrapper">
                  <h3 className="pharmacy_header_name">
                    Dispensed medications
                  </h3>

                  {filteredPrescriptions.map((item, idx) => {
                    let prescriptionsDetails = [];
                    try {
                      const payload = JSON.parse(item.action.payload);
                      prescriptionsDetails = payload.prescriptionsDetails || [];
                    } catch (error) {
                      console.error("Error parsing payload:", error);
                    }

                    const formattedDate = dayjs(item.createdOn).format(
                      "dddd, D MMMM"
                    );

                    return (
                      <div className="medications-container" key={idx}>
                        <div className="dispensed-date">
                          <p>{formattedDate}</p>
                        </div>
                        <div className="medications-list">
                          {prescriptionsDetails.map((detail, detailIdx) => (
                            <div className="medications-item" key={detailIdx}>
                              <div className="medications-item-head">
                                <p>{detail.value || "Unnamed medication"}</p>
                              </div>
                              <div className="medications-item-desc">
                                <p>{detail.notes || "No notes provided."}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default DashboardPrescriptions;

